const domain = "async-action";
var RequestStatus = /* @__PURE__ */ ((RequestStatus2) => {
  RequestStatus2[RequestStatus2["None"] = 0] = "None";
  RequestStatus2[RequestStatus2["Progress"] = 1] = "Progress";
  RequestStatus2[RequestStatus2["Error"] = 2] = "Error";
  return RequestStatus2;
})(RequestStatus || {});
export {
  RequestStatus,
  domain
};
//# sourceMappingURL=types.js.map
